import { makeHook } from "../../utils/makeSingleArgHook";
import { ExpandedTradeProposalBundle, getTradeProposalBundle, MiniTradeProposal, url, } from "../request/getTradeProposalBundle";
import { TradeProposalBundleId, TradeProposalBundleStatus, TradeProposalBundleStatuses, } from "../types";
import { keyMaker as allBundlesKeyMaker } from "./useGetTradeProposalBundles";
export { MiniTradeProposal, TradeProposalBundleId, TradeProposalBundleStatuses, TradeProposalBundleStatus, ExpandedTradeProposalBundle, };
export function keyMaker(bundleId) {
    return [...allBundlesKeyMaker(null), url(bundleId)];
}
const useGetTradeProposalBundles = makeHook(getTradeProposalBundle, keyMaker);
export default useGetTradeProposalBundles;
//# sourceMappingURL=useGetTradeProposalBundle.js.map